import { core } from "@icc/shared/helpers/b2b";
import { ExchangeRate } from "./exchange-rate.interface";

export function exchange(value: number, from: string, to: string, exchangeRates: ExchangeRate[], cache: Map<string, number> = new Map()) {
    if (from === to) {
        return value;
    }
    if (!value) {
        return value;
    }
    const key = `${from}-${to}`;
    let rate = cache.get(key);
    if (rate == null) {
        rate = findExchangeRate(from, to, exchangeRates);
        cache.set(key, rate);
    }
    if (rate != null) {
        return core.round(value * rate);
    }
    return value;
}

export function compiledExchange(from: string, to: string, exchangeRates: ExchangeRate[], cache: Map<string, number> = new Map()) {
    if (from === to) {
        return (value: number) => value;
    }
    const key = `${from}-${to}`;
    let rate = cache.get(key);
    if (rate == null) {
        rate = findExchangeRate(from, to, exchangeRates);
        cache.set(key, rate);
    }
    if (rate != null) {
        return (value: number) => core.round(value * rate);
    }
    return (value: number) => value;
}


export function findExchangeRate(from: string, to: string, exchangeRates: any[]) {
    const adjacencyList = prepareAdjacencyList(exchangeRates);

    const visited = new Set();
    const pred = new Map();
    const distance = new Map();
    const queue = [from];
    distance.set(from, 0);
    visited.add(from);

    while (queue.length > 0) {
        const currency = queue.shift();
        const destinations = adjacencyList.get(currency);

        if (destinations) {
            for (const destination of destinations) {
                if (!visited.has(destination.code)) {
                    visited.add(destination.code);
                    distance.set(destination.code, distance.get(currency) + 1);
                    pred.set(destination.code, currency);
                    queue.push(destination.code);

                    if (destination.code === to)  {
                        return getRateFromPath(to, pred, adjacencyList);
                    }
                }
            }
        }
    }
    return null;
}

function getRateFromPath(to: string, pred: Map<any, any>, adjacencyList: Map<any, any>) {
    const currencyPath: any[] = [to];
    let crawl = to;
    let rate = 1;
    while (pred.has(crawl)) {
        currencyPath.push(pred.get(crawl));
        rate *= (adjacencyList.get(pred.get(crawl)).find(c => c.code === crawl)?.rate ?? 1);
        crawl = pred.get(crawl);
    }
    return rate;
}

function prepareAdjacencyList(exchangeRates: ExchangeRate[]) {
    const adjacencyList = new Map();
    exchangeRates.forEach(rate => {
        if (!adjacencyList.has(rate.code_from)) {
            adjacencyList.set(rate.code_from, []);
        }
        if (!adjacencyList.has(rate.code_to)) {
            adjacencyList.set(rate.code_to, []);
        }
        adjacencyList.get(rate.code_from).push({
            code: rate.code_to,
            rate: 1 / rate.rate_buy
        });
        adjacencyList.get(rate.code_to).push({
            code: rate.code_from,
            rate: rate.rate_sell
        });
    });
    return adjacencyList;
}
